import { useEffect, useState } from "react";

import {
  RESEND_COOLDOWN_SECONDS,
  secondsUntilResend,
} from "components/OtpVerification/cooldown";

/** Whole seconds left of the resend wait that began at `startedAt`; 0 when
 * there is none. Counting begins again whenever `startedAt` changes. */
export function useCooldownSeconds(startedAt: number | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (startedAt === null) return;
    const readyAt = startedAt + RESEND_COOLDOWN_SECONDS * 1000;
    let timer: number | undefined;
    const tick = () => {
      const current = Date.now();
      setNow(current);
      if (current >= readyAt) window.clearInterval(timer);
    };
    timer = window.setInterval(tick, 1000);
    tick();
    return () => window.clearInterval(timer);
  }, [startedAt]);

  if (startedAt === null) return 0;
  return secondsUntilResend(startedAt + RESEND_COOLDOWN_SECONDS * 1000, now);
}
